<template>
  <div>
    <LayerHeatmap01 :before="before" />
    <LayerHeatmap02 :before="before" />
    <LayerHeatmapStatic :before="before" />
    <LayerHeatmapDynamic :before="before" />
  </div>
</template>

<script>
import LayerHeatmapStatic from './LayerHeatmapStatic.vue'
import LayerHeatmapDynamic from './LayerHeatmapDynamic.vue'
import LayerHeatmap01 from './LayerHeatmap01.vue'
import LayerHeatmap02 from './LayerHeatmap02.vue'

export default {
  name: 'LayerHeatmap',
  components: {
    LayerHeatmapStatic,
    LayerHeatmapDynamic,
    LayerHeatmap01,
    LayerHeatmap02
  },
  props: {
    before: {
      type: String,
      required: true
    }
  }
}
</script>
